import {Box, Stack, Text} from '@primer/react-brand/esm'

import {
  PLAN_TYPES,
  type PlanType,
} from '../../../../../../brand/components/PlanTypeSegmentedControl/PlanTypeSegmentedControl'
import type {GenericContent} from '../../../../../../brand/lib/types/contentful'

import {CompareTableColumn} from './CompareTableColumn'
import styles from './styles.module.css'

type Props = {
  contentfulContent: GenericContent
  columns: GenericContent[]
  planType: PlanType
}

export function CompareTableHeader(props: Props) {
  const {contentfulContent, columns, planType} = props
  const {heading} = contentfulContent.fields

  const plans = {
    [PLAN_TYPES.Individual]: ['Free', 'Pro', 'ProPlus', 'Max'],
    [PLAN_TYPES.Business]: ['Business', 'Enterprise'],
  }

  const filteredTableColumns = columns.filter(column => plans[planType].includes(column.fields.id ?? ''))

  return (
    <Stack direction="horizontal" gap={32} padding="none" className={styles.root}>
      <Box className={styles.heading}>
        <Text size="500">{heading}</Text>
      </Box>

      <Stack role="rowgroup" direction="vertical" gap={4} padding="none" className={styles.columns}>
        <Stack role="row" direction="horizontal" gap={32} padding="none">
          <div role="columnheader" className={styles.columnHeaderLabel}>
            <span className="sr-only">Pricing plans</span>
          </div>

          {filteredTableColumns.map(column => (
            <CompareTableColumn key={column.sys.id} column={column} />
          ))}
        </Stack>
      </Stack>
    </Stack>
  )
}
